import { render, staticRenderFns } from "./TaskReportDetailTab.vue?vue&type=template&id=89547de2&scoped=true&"
import script from "./TaskReportDetailTab.vue?vue&type=script&lang=js&"
export * from "./TaskReportDetailTab.vue?vue&type=script&lang=js&"
import style0 from "./TaskReportDetailTab.vue?vue&type=style&index=0&id=89547de2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89547de2",
  null
  
)

export default component.exports